import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var HardDrive = createReactComponent("HardDrive", ["svg", defaultAttributes, [["line", {
  x1: "22",
  y1: "12",
  x2: "2",
  y2: "12",
  key: "1kub4m"
}], ["path", {
  d: "M5.45 5.11L2 12v6a2 2 0 002 2h16a2 2 0 002-2v-6l-3.45-6.89A2 2 0 0016.76 4H7.24a2 2 0 00-1.79 1.11z",
  key: "1vlmtz"
}], ["line", {
  x1: "6",
  y1: "16",
  x2: "6.01",
  y2: "16",
  key: "1qihrp"
}], ["line", {
  x1: "10",
  y1: "16",
  x2: "10.01",
  y2: "16",
  key: "1qqomo"
}]]]);
export default HardDrive;